import React from 'react';
import styled from 'styled-components';

const StyledList = styled.ul`
  display: flex;
  justify-content: space-between;
  width: 70%;
  margin: 0 auto auto;
  list-style: none;
  padding: 0;
  
  @media screen and (max-width: 374px) {
    width: 85%;
  }
`


const CardIcons = () => (
    <StyledList>
        <li>
            <img src='../images/visa.png' alt='Visa' width='57' height='35'/>
        </li>
        <li>
            <img src='../images/mastercard.png' alt='Visa' width='57' height='35'/>
        </li>
        <li>
            <img src='../images/amex.png' alt='Visa' width='57' height='35'/>
        </li>
        <li>
            <img src='../images/discover.png' alt='Visa' width='57' height='35'/>
        </li>

    </StyledList>
)

export default CardIcons;